/**
 * Hatton Labs - Notify Me Auto-Trigger
 */
(function () {
  'use strict';

  var urlParams = new URLSearchParams(window.location.search);
  var fromUrl = urlParams.get('notify') === 'true';
  var fromStorage = false;

  try { fromStorage = sessionStorage.getItem('hatton_notify') === 'true'; } catch(e) {}

  if (!fromUrl && !fromStorage) return;

  if (fromUrl) {
    try { sessionStorage.setItem('hatton_notify', 'true'); } catch(e) {}
    urlParams.delete('notify');
    var cleanUrl = window.location.pathname;
    var remaining = urlParams.toString();
    if (remaining) cleanUrl += '?' + remaining;
    window.history.replaceState({}, '', cleanUrl);
  }

  console.log('[Notify PDP] notify trigger detected');
  var triggered = false;

  function tryClick() {
    if (triggered) return;

    // Get ALL notify buttons and use the LAST one (Swym's replaced version)
    var btns = document.querySelectorAll('.js-product-main__button-notify');
    var btn = btns[btns.length - 1];
    if (!btn || !btn.closest('form') || !btn.closest('form').isConnected) return;

    // Check form has submit listeners (Swym attached)
    var form = btn.closest('form');
    if (!form) return;

    triggered = true;

    // Select first size
    var sizeLabel = document.querySelector('.c-product-main__option-label');
    if (sizeLabel) {
      sizeLabel.click();
      console.log('[Notify PDP] Auto-selected first size');
    }

    setTimeout(function () {
      // Re-query to get the connected button
      var freshBtns = document.querySelectorAll('.js-product-main__button-notify');
      var freshBtn = freshBtns[freshBtns.length - 1];
      if (freshBtn) {
        freshBtn.click();
        console.log('[Notify PDP] Clicked notify button');
      }
      try { sessionStorage.removeItem('hatton_notify'); } catch(e) {}
    }, 1000);
  }

  // Watch for Swym to finish replacing the form
  var observer = new MutationObserver(function () {
    var btns = document.querySelectorAll('.js-product-main__button-notify');
    if (btns.length >= 2 && window._swat) {
      // Swym has cloned the form, wait a beat then click
      observer.disconnect();
      setTimeout(tryClick, 500);
    }
  });

  window.addEventListener('load', function () {
    observer.observe(document.body, { childList: true, subtree: true });
    // Fallback
    setTimeout(function () {
      observer.disconnect();
      tryClick();
    }, 8000);
  });
})();